import Carrusel from "../../components/Carrusel/main";
import Formulario from "./formulario";
import Novedades from "../../pages/Novedades/main";
import { LineaMorada } from "../../utilities/LineaMorada";
import { PlecaMorada } from "../../utilities/PlecaMorada";

export default function Home(){ 
    return(
        <> 
            <div className="container-fluid mt-5 px-0"><Carrusel seccion={1}/></div>
            <LineaMorada />
            <Novedades tipo={1}/>            
            <div className="container-fluid mt-5">
                <div className="row">
                    <div className="col-12 banner_title_blue text-center">
                        <h1 className="abel_font mb-0">Biblioteca virtual</h1>
                    </div>
                </div>
            </div>
            <Carrusel seccion={2}/>            
            <div className="container-fluid mt-4">
                <div className="row">
                    <div className="col-12 main_title text-center my-2"><h1 className="abel_font">Contáctanos</h1></div>
                    <div className="col-12 container_form_contact d-flex align-items-center">
                        <div className="container my-5">
                            <div className="row">
                                <Formulario />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <PlecaMorada/>
        </>
    )
}


